import { useEffect } from "react";
import NoStreamingCard from "./NoStreamingCard";
import StreamNotice from "./StreamNotice";
import { Server } from "lucide-react";
import LivePlayer from "./LivePlayer2";
import { useState } from "react";

export default function LiveMatch({ data }) {

  const [selectedServer, setSelectedServer] = useState(null);
  const matchData = data?.match_id ? { ...data, servers: JSON.parse(data?.servers) } : {}

  useEffect(() => {
    if(!selectedServer){
      if (matchData?.match_id) {
        if (
          matchData?.servers?.length > 0
        ) {
          setSelectedServer(
            matchData?.servers[0]
          );
        }
      }
    }
  }, [matchData])

  return (
    <>
      {matchData?.match_id &&
        <>
          <StreamNotice />

          {/* VIDEO PLAYER */}

          <div className="mb-6 rounded-xl overflow-hidden border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow">

            <div className="relative aspect-video bg-black">

              {selectedServer?.stream_url ? (
                <>
                  {selectedServer?.stream_type === 'iframe' ? (
                    <iframe
                      src={
                        selectedServer.stream_url
                      }
                      className="absolute inset-0 w-full h-full"
                      allowFullScreen
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    />
                  ) : (
                    <LivePlayer streamUrl={selectedServer.stream_url} />
                  )}
                </>
              ) : (
                <NoStreamingCard />
              )}
            </div>

          </div>

          {/* SERVERS */}

          <div className="mb-6">

            <div className="flex items-center gap-2 mb-3">

              <Server
                size={16}
                className="text-gray-500"
              />

              <span className="text-sm font-medium text-gray-500">
                Select Server:
              </span>

            </div>

            <div className="flex flex-wrap gap-3">

              {matchData?.servers?.map(
                (
                  server,
                  index
                ) => (

                  <button
                    key={index}
                    onClick={() =>
                      setSelectedServer(
                        server
                      )
                    }
                    className={`
                                    px-4 py-2
                                    rounded-lg
                                    min-w-[120px]
                                    font-semibold
                                    text-white
                                    transition-all
                                    hover:scale-105

                                    ${selectedServer?.stream_url ===
                        server.stream_url
                        ? "bg-gradient-to-r from-blue-600 to-pink-500"
                        : "bg-gray-700"
                      }
                                    `}
                  >

                    {
                      server.server_name
                    }

                  </button>
                )
              )}

            </div>

          </div>

        </>
      }
    </>
  );
}